module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/main_pc_b4bda7331d52274cd35dcacce606411c.jpg";